import { validateEmployeeId } from "./inputValidation";
import {
  DATE_TYPE_IS_REQUIRED_MESSAGE,
  EMPLOYEE_TRADE_ROLE_IS_REQUIRED_MESSAGE,
  SHIFT_DATE_IS_REQUIRED_MESSAGE,
  STATUS_IS_REQUIRED_MESSAGE,
  TRADE_TYPE_IS_REQUIRED_MESSAGE,
  TIME_OFF_TYPE_IS_REQUIRED_MESSAGE,
  WORKGROUP_IS_REQUIRED_MESSAGE,
  INVALID_EMPLOYEE_ID,
} from "./messageConstants";
import { getJobCodeData } from "./employeeConfigUtils";

export function validateEmployeeDataForGeneratingReport(input) {
  if (input === null || Object.keys(getJobCodeData()).indexOf(input.jobCode) < 0) {
    return INVALID_EMPLOYEE_ID;
  }
  return "";
}

export function validateAdminDataForGeneratingReport(input) {
  if (input === null || Object.keys(getJobCodeData()).indexOf(input.jobCode) < 0) {
    return INVALID_EMPLOYEE_ID;
  }
  return "";
}

export function validateEmployeeAdminId(input) {
  if (input.trim().charAt(0).toUpperCase() !== "E") {
    return INVALID_EMPLOYEE_ID + ' - start with "e"';
  } else if (!input.match("e\\d{0,6}$")) {
    return INVALID_EMPLOYEE_ID;
  }
  return "";
}

export function validateReportShiftDate(input) {
  if (input === null) {
    return SHIFT_DATE_IS_REQUIRED_MESSAGE;
  }
  return "";
}

export function validateDateType(input) {
  if (input === "") {
    return DATE_TYPE_IS_REQUIRED_MESSAGE;
  }
  return "";
}

export function validateTradeTypeList(input) {
  if (!!input && input.length <= 0) {
    return TRADE_TYPE_IS_REQUIRED_MESSAGE;
  }
  return "";
}

export function validateEmployeeTradeRoleList(input, employeeData) {
  if (employeeData !== null) {
    if (!!input && input.length <= 0) {
      return EMPLOYEE_TRADE_ROLE_IS_REQUIRED_MESSAGE;
    }
  }
  return "";
}

export function validateReportEmployeeId(input, employeeTradeRoleList) {
  if (employeeTradeRoleList.length <= 0) {
    if (input.trim() === "") {
      return "";
    } else if (input.trim().charAt(0).toUpperCase() !== "E") {
      return INVALID_EMPLOYEE_ID + ' - start with "e"';
    } else if (!input.match("e\\d{0,6}$")) {
      return INVALID_EMPLOYEE_ID;
    }
  } else {
    return validateEmployeeId(input);
  }
  return "";
}

export function validateAdminId(input) {
  if (input.trim() === "") {
    return "";
  } else if (input.trim().charAt(0).toUpperCase() !== "E") {
    return 'Invalid Admin ID - start with "e"';
  } else if (!input.match("e\\d{0,6}$")) {
    return "Invalid Admin ID";
  }
  return "";
}

export function validateWorkgroupList(input) {
  if (!!input && input.length <= 0) {
    return WORKGROUP_IS_REQUIRED_MESSAGE;
  }
  return "";
}

export function validateStatusList(input) {
  if (!!input && input.length <= 0) {
    return STATUS_IS_REQUIRED_MESSAGE;
  }
  return "";
}

export function validateTimeOffTypeList(input) {
  if (!!input && input.length <= 0) {
    return TIME_OFF_TYPE_IS_REQUIRED_MESSAGE;
  }
  return "";
}

export function validateTORReportEmployeeId(input) {
  if (input === "") {
    return "";
  } else {
    return validateEmployeeId(input);
  }
}
